var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { IossRegistration } from "./IossRegistration";
export class SearchResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "Count");
    /**
     */
    __publicField(this, "IossRegistrations");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchResult
     */
    __publicField(this, "$type", "V1.Companies.IossRegistrations.Search.SearchResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Count = _data["Count"];
      if (_data["IossRegistrations"] && _data["IossRegistrations"].constructor === Array) {
        this.IossRegistrations = [];
        for (let item of _data["IossRegistrations"]) {
          const iossRegistrations_ = new IossRegistration();
          this.IossRegistrations.push(iossRegistrations_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Count"] = this.Count;
    if (this.IossRegistrations && this.IossRegistrations.constructor === Array) {
      _data["IossRegistrations"] = [];
      for (let item of this.IossRegistrations) {
        _data["IossRegistrations"].push(item.toJSON());
      }
    }
    return _data;
  }
}
